import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { SidePanelService } from './side-panel.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { MatDrawer } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';
import { AdditionalInstructionsModalComponent } from '@app/shared/manual/additional-instructions-modal/additional-instructions-modal.component';
import { ManualPage } from '@app/shared/models/enums/manualPage.enum';

interface SidePanelConfig {
  title: string;
  description: string;
  children: {
    title: string;
    description: string;
  }[];
  manualKey?: ManualPage;
}

@Component({
  selector: 'flow-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss'],
})
export class SidePanelComponent implements AfterViewInit, OnDestroy {
  @Input() sidePanel: MatDrawer;
  destroy$ = new Subject<void>();
  config$: Observable<SidePanelConfig>;

  constructor(
    private sidePanelService: SidePanelService,
    private dialog: MatDialog
  ) {}

  ngAfterViewInit(): void {
    this.config$ = this.sidePanelService.getConfig$();
    this.toggleSidePanel();
  }
  openAdditionalInstructions(manualKey?: ManualPage): void {
    if (!manualKey) {
      return;
    }
    this.dialog.open(AdditionalInstructionsModalComponent, {
      width: '900px',
      maxWidth: '92vw',
      maxHeight: '90vh',
      autoFocus: false,
      panelClass: 'additional-instructions-dialog',
      data: { manualKey },
    });
  }

  toggleSidePanel() {
    this.sidePanelService.toggle$.pipe(takeUntil(this.destroy$)).subscribe(toggle => {
      this.sidePanel.open();
    });
  }

  closeSidePanel() {
    this.sidePanel.close();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
